export function removeInitialSplash() {
  if (typeof document === "undefined") {
    return;
  }

  document.querySelectorAll(".splash").forEach((element) => {
    element.remove();
  });
}

export function scheduleInitialSplashRemoval() {
  if (typeof window === "undefined") {
    removeInitialSplash();
    return;
  }

  const remove = () => removeInitialSplash();

  if (typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(remove);
    return;
  }

  window.setTimeout(remove, 0);
}
